import { ProductPriceList } from '../types'
import { useTranslation } from 'next-i18next/pages'
import { useGetLanguage } from 'hooks/useGetLanguage'
import { CUSTOMER_TYPES } from '@boltenergy-be/shared'

const PricelistLine = ({ product, name, pricelists }: ProductPriceList) => {
  // i18n
  const { t } = useTranslation('pricelists')
  const language = useGetLanguage()

  return (
    <li key={`el-${product}`}>
      {name}: &nbsp;
      {/* RESIDENTIAL */}
      <a href={`https://${pricelists[CUSTOMER_TYPES.residential][language]}`} target="_blank" rel="noreferrer">
        {t('res')}
      </a>
      &nbsp; / &nbsp;
      {/* PROFESSIONAL */}
      <a href={`https://${pricelists[CUSTOMER_TYPES.professional][language]}`} target="_blank" rel="noreferrer">
        {t('pro')}
      </a>
    </li>
  )
}

export default PricelistLine
